import React from "react";
import { HairlineList } from "@/components/primitives";
import FaqSection from "@/components/FaqSection";
import { electraFaqs } from "@/content/faqs";
import { useDocumentMeta } from "@/lib/meta";
import {
  ProductHero,
  ContentSection,
  AdjacentCrossSell,
  ProductFinalCTA,
} from "@/components/ProductSections";

const IMG = "https://images.unsplash.com/photo-1758518731462-d091b0b4ed0d";

export default function ElectraHR() {
  useDocumentMeta({
    title: "Electra HR",
    description:
      "Electra HR is the practical people-support layer — competent HR support without building an in-house department or bureaucratic drag.",
    path: "/electra-hr",
  });
  return (
    <div data-testid="electra-hr-page">
      <ProductHero
        testid="electra-hero"
        eyebrow="Electra HR · People"
        title="Practical HR support for firms without an HR department."
        subhead="Electra HR gives owner-managed firms access to sharp, usable HR support without adding internal headcount or bureaucratic drag. Designed for firms that need competent people support but want to stay in control."
        primaryLabel="Book a walkthrough"
        secondaryLabel="See the stack"
        secondaryTo="#adjacent"
        image={IMG}
      />

      <ContentSection
        n="01"
        eyebrow="The people layer"
        title="Competent people support, without building a department"
        testid="electra-what"
      >
        <p className="text-lg leading-relaxed text-foreground">
          Electra HR is the people layer in the autonomy stack. It gives owner-managed firms
          capable, practical HR support without the cost and drag of an internal department — and
          without handing control to an opaque outsourced provider.
        </p>
        <p className="mt-5 leading-relaxed text-muted-foreground">
          It is built for businesses that need sensible people capability but want to stay in
          control of how their firm treats, manages and develops its team.
        </p>
        <p className="mt-5 leading-relaxed text-muted-foreground">
          Electra HR is Bonsai-connected: solicitor-led legal support available via Bonsai Law when
          a matter escalates.
        </p>
        <HairlineList
          testid="electra-list"
          items={[
            "Sharp, usable HR support without internal headcount",
            "No bureaucratic drag or empty process for its own sake",
            "Owner stays in control of people decisions",
            "Sits alongside CaseMinder and ComplianceMinder as one ecosystem",
          ]}
        />
      </ContentSection>

      <FaqSection
        eyebrow="Electra HR FAQ"
        title="Questions owners ask"
        items={electraFaqs}
        testid="electra-faq"
        bg
      />

      <AdjacentCrossSell
        testid="electra-adjacent"
        title="Put owner control across operations and compliance too"
        body="Electra HR handles the people layer. Add CaseMinder for the operational spine, and ComplianceMinder for live policy and firmwide risk — one owner-control ecosystem rather than fragmented support."
        to="/caseminder"
        label="Explore CaseMinder"
      />

      <ProductFinalCTA
        testid="electra-final-cta"
        title="Sensible people capability. Owner control intact."
        body="Add the people layer without building a department."
        label="Book a walkthrough"
      />
    </div>
  );
}
